module.exports = __webpack_public_path__ + "img/1.37798069.jpg";